var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppIcon',{staticClass:"arrow",class:[_vm.direction, { '-n90': _setup.hasNegativeOffset }],attrs:{"name":_vm.icon,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }